import React from "react";
import {IOrder} from "../../models/orders/order";
import {useGlobalContext} from "../../hooks/globalContext";
import {CURRENCY} from "../../utils/options/options";

function deliveryPrice(order: IOrder) {
    return order.externalDeliveryPrice == null
        ? "Не указана"
        : `${new Intl.NumberFormat("ru-RU", {maximumFractionDigits: 2}).format(order.externalDeliveryPrice / 100)} ${CURRENCY[order.currency]}`;
}

export function YandexDeliverySummary({order}: {order: IOrder}) {
    return <div className="order-delivery-summary">
        <strong>Яндекс Доставка</strong>
        <div>{order.delivery.data?.address || "Адрес не указан"}</div>
        <div className="order-delivery-summary__price">Доставка: {deliveryPrice(order)}</div>
    </div>;
}

export function YandexDeliveryDetails({order}: {order: IOrder}) {
    const {i18n} = useGlobalContext();
    const data = order.delivery.data;
    return <div className="order-delivery-details">
        {[
            [i18n.home_address(), data?.address || "Адрес не указан"],
            [i18n.other_address(), data?.detailedAddress],
            ["Подъезд", data?.porch],
            ["Этаж", data?.floor],
            ["Квартира / офис", data?.flat],
            ["Домофон", data?.doorCode],
            ["Инструкция к домофону", data?.doorCodeExtra],
            [i18n.delivery_comment(), data?.deliveryComment],
        ].filter(([, value]) => value?.trim()).map(([label, value]) =>
            <div key={label} className="row mb-2" style={{display: "flex", justifyContent: "flex-start"}}>
                <div className="col-md-6"><div className="tx-gray">{label}:</div></div>
                <div className="col-md-6">{value}</div>
            </div>
        )}
    </div>;
}

export function YandexDeliveryPriceRow({order, columns = 3}: {order: IOrder; columns?: number}) {
    const {i18n} = useGlobalContext();
    return <tr className="order-delivery-price-row">
        <td data-title={i18n.pl_item()} colSpan={columns - 1}>Доставка Яндекс</td>
        <td data-title={i18n.price()} className="number-td">{deliveryPrice(order)}</td>
    </tr>;
}
